import { render, staticRenderFns } from "./ItemPreviewCardGroup.vue?vue&type=template&id=0aef77f9&"
import script from "./ItemPreviewCardGroup.vue?vue&type=script&lang=js&"
export * from "./ItemPreviewCardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "8a5dc0a6"
  
)

export default component.exports